import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/notifications`

export default (payload = {}) =>
  http.post(api, payload)
